import Navbar from "@/components/Navbar";
import HeroCarousel from "@/components/HeroCarousel";
import IntroHero from "@/components/IntroHero";
import About from "@/components/About";
import Products from "@/components/Products";
import Solutions from "@/components/Solutions";
import Sectors from "@/components/Sectors";
import Partners from "@/components/Partners";
import WhyChoose from "@/components/WhyChoose";
import HowWeWork from "@/components/HowWeWork";
import Support from "@/components/Support";
import Gallery from "@/components/Gallery";
import FaqSection from "@/components/FaqSection";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";

export default function Home() {
  return (
    <div className="bg-white text-medis-navy" data-testid="home-page">
      <Navbar />
      <main>
        <HeroCarousel />
        <IntroHero />
        <About />
        <Products />
        <Solutions />
        <Sectors />
        <Partners />
        <WhyChoose />
        <HowWeWork />
        <Support />
        <Gallery />
        <FaqSection />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
